export default {
  'Text': 'Texto',
  'Styles': 'Estilos',
  'Text here': 'Texto aqui',
  'Add subtitles': 'Adicionar legenda',
  'Text Color': 'Cor de texto',
  'Outline': 'Contorno',
  'Background': 'Fundo',
  'Position': 'Posição',
}